import React, { Component, useRef, Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import Moment from 'moment';
import { Common } from '../../../../core/common';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { UserType } from '../../../../models/pages/login.d';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import Loading from '../../../loading/loading';

const T = Translator.create();
let _common: Common;

class VideoQuestion extends React.Component<ISignleActivityCard> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
    }

    public render() {
        return (
            <div className="question-wrapper" id={'question_' + this.props.activityCard!.activityId} style={{zIndex: 999999, position: "absolute"}}>
                <div className="q_hold">
                    <div className="quest" contentEditable={false}>
                        <form autoComplete={'off'}>
                            <h4 />
                            <ul />
                            <button className="btn btn-success" type="submit">
                                {T.t('r_video_submit')}
                            </button>
                        </form>
                    </div>
                    <div className="answer">
                        <h4 />
                        <p style={{ color: 'white' }} />
                        <a href="#" className="btn btn-success btn_go">
                            {T.t('r_video_nextepisode')}
                        </a>{' '}
                        <a href="#" className="btn btn-danger btn_repeat_video">
                            {T.t('r_video_watchagain')}
                        </a>
                        <a href="#" className="btn btn-danger btn_go_to_back">
                           {T.t('r_go_to_back')}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userType: state.login.identitiy.userType,
        coursePageActivityId: state.coursePage.coursePageActivityId
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CVideoQuestion = connect(
    mapStateToProps,
    dispatchProps
)(VideoQuestion);

export default CVideoQuestion;
